<h2 mat-dialog-title>
  <mat-icon class="icon-24" svgIcon="socket_type_ccs2"></mat-icon>
  Tilknytning af ladepunkter til betalingsterminal {{ paymentTerminal.serialNumber }}
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  @if (paymentTerminalConnectorRelationForm && typeAheadModel) {
    <form [formGroup]="paymentTerminalConnectorRelationForm">
      <div class="form-row">
        <mat-form-field class="actions__organizations">
          <mat-label>Vælg organisation</mat-label>
          <div [formGroup]="typeAheadModel">
            <input type="text" #organizationSelect formControlName="typeAheadQuery" [matAutocomplete]="auto" matInput placeholder="Vælg" />
          </div>
          <mat-autocomplete
            #auto="matAutocomplete"
            hideSingleSelectionIndicator="true"
            [displayWith]="displayFn"
            (optionSelected)="selectOrganization($event.option.value)"
            okCustomDropDownArrowDirective>
            @for (organization of filteredOrganizations; track organization) {
              <mat-option [value]="organization">
                {{ organization.name }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (organizationId) {
            <mat-icon matSuffix class="clear-input-field-button" (click)="resetOrganizationTypeAhead()">close</mat-icon>
          }
          <mat-icon matSuffix></mat-icon>
        </mat-form-field>
      </div>
      <div class="form-row custom-selector-field" [class.disabled-and-muted]="!this.organizationId">
        <span class="custom-selector-field__row-label">
          Ladepunkter
          @if (!this.organizationId) {
            <span>Kræver en valgt organisation ovenfor</span>
          }
        </span>
        <button type="button" (click)="openConnectorSelector()" class="custom-selector-field__toggle">
          <mat-icon svgIcon="socket_type_ccs2"></mat-icon>
          <span class="custom-selector-field__input-label">Vælg ladepunkter</span>
          @if (connectorBadgeCount > 0) {
            <span class="custom-selector-field__chosen">
              <div matBadge="{{ connectorBadgeCount }}" matBadgeOverlap="false">Valgt</div>
            </span>
          }
          <mat-icon class="custom-selector-field__arrow" matSuffix>keyboard_arrow_down</mat-icon>
        </button>
        @if (connectorBadgeCount > 0) {
          <button class="custom-selector-field__clear-input" type="button" (click)="resetConnectors()" aria-label="Ryd indhold i feltet">
            <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
          </button>
        }
      </div>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if (!wasSaved) {
    <button class="actions__button margin--right-2" mat-dialog-close type="button" mat-button>Annuller</button>
  }

  @if (!wasSaved) {
    <button
      class="actions__button"
      type="button"
      mat-flat-button
      color="primary"
      [disabled]="paymentTerminalConnectorRelationForm.invalid || saving"
      [class.spinner]="saving"
      (click)="savePaymentTerminalConnectorRelation()">
      Gem
    </button>
  }

  @if (wasSaved) {
    <button class="actions__button" type="button" mat-flat-button color="primary" (click)="close()">Luk</button>
  }
</mat-dialog-actions>
